import React from "react";
import doctorImg from "../../assets/images/About/1.jpg";
import coupleImg from "../../assets/images/Home/dr-vibha.jpeg";
const THEME = {
  primary: "#546E7A",
  bgSection: "#F9FBFA",
};

const AboutDoctor = () => {
  return (
    <div className="w-full" style={{ fontFamily: THEME.fontMain }}>
      {/* ===== DREAMS SECTION ===== */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Bringing Dreams Of <br />
              <span style={{ color: THEME.primary }}>Parenthood To Life</span>
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              At Dr. Vibha Singh Gynaecology & Fertility Clinic, we understand
              that infertility is not just a medical challenge—it’s an emotional
              journey.
            </p>
            <div
              className="h-1 w-20"
              style={{ backgroundColor: THEME.primary }}
            ></div>
          </div>
          <div className="relative">
            <img
              src={doctorImg}
              alt="Parenthood"
              className="rounded-3xl shadow-2xl w-full object-cover h-[400px] md:h-[450px]"
            />
          </div>
        </div>
      </section>

      {/* ===== DOCTOR SECTION ===== */}
      <section
        style={{ backgroundColor: THEME.bgSection }}
        className="py-20 px-4 md:px-10"
      >
        <div className="max-w-7xl mx-auto bg-white rounded-[2.5rem] shadow-2xl overflow-hidden grid lg:grid-cols-[30%_70%] items-stretch">
          {/* Left Image */}
          <div className="h-[450px] lg:h-auto">
            <img
              src={coupleImg}
              alt="Dr. Vibha Singh"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Right Content */}
          <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-center">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4">
              About{" "}
              <span style={{ color: THEME.primary }}>Dr. Vibha Singh</span>
            </h2>

            <p className="text-gray-600 mb-10 leading-relaxed text-base md:text-lg">
              With over{" "}
              <span className="font-bold text-gray-900">
                20 years of experience
              </span>{" "}
              in Obstetrics, Gynecology, and ART, Dr. Vibha Singh is a trusted
              name in women’s healthcare.
            </p>

            <h3 className="font-bold text-2xl uppercase tracking-widest mb-8 text-gray-900 flex items-center gap-3">
              <span
                className="h-[2px] w-8"
                style={{ backgroundColor: THEME.primary }}
              ></span>
              Work Experience
            </h3>

            {/* ✅ UPDATED EXPERIENCE */}
            <div className="grid sm:grid-cols-2 gap-x-10 gap-y-6">
              {[
                {
                  role: "Visiting Consultant",
                  hosp: "Yatharth Super Speciality Hospital",
                },
                {
                  role: "Visiting Consultant",
                  hosp: "Numed Hospital",
                },
                {
                  role: "Ex - Senior Consultant",
                  hosp: "MAX Hospital, Muzaffarpur, Bihar",
                },
                {
                  role: "Ex - Senior Consultant",
                  hosp: "Om Sai Nursing Home, Juran Chapra, Muzaffarpur, Bihar",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="border-l-4 pl-4 hover:translate-x-1 transition-transform"
                  style={{ borderColor: THEME.primary }}
                >
                  <p className="font-bold text-gray-900 text-sm md:text-base leading-tight">
                    {item.role}
                  </p>
                  <p className="text-gray-500 text-xs md:text-sm mt-1">
                    {item.hosp}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutDoctor;
